import React, { useEffect, useState, Fragment } from 'react';
import { Pagination, PageHeader, paginate } from '../../../Common';
import { TableContent } from '../../Common/Table/tableContent';
import services from '../services';
import TextField from '@material-ui/core/TextField';
import $ from 'jquery';
import { Fields, validateProperty, validate, Card } from "../../Common";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { search } from '../../Common';
import { factoryItemValidationSchemaObject } from '../../Data';
import Joi from '@hapi/joi';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'TASKTEMPLATE';

export function TaskTemplateListing(props){

    const [estates, setEstates] = useState()
    const [allTaskTemplates, setAllTaskTemplates] = useState([])
    const [pageSize, setPageSize] = useState(4)
    const [currentPage, setCurrentPage] = useState(1);
    const [groups, setGroups] = useState();
    const [collectionPoints, setCollectionPoints] = useState([]);
    const [searchForm, setSearchForm] = useState({
        groupID: 0,
        operationEntityID: 0,
        collectionPointID: 0
    });
    const [factories, setFactories] = useState();
    const contentRowNames = ["taskName", "estateTaskName", "taskDescription", "taskExpiration", "collectionPointName", "numberOfWorkers", "isActive"]
    const [errors, setErrors] = useState({});
    const [isTableHide, setIsTableHide] = useState(true);
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    useEffect(() => {
    trackPromise(
        getPermissions()
        )
    }, []);

    useEffect(() => {
        trackPromise(
            getEstates()
        )
    }, [searchForm.groupID]);

    useEffect(() => {
        if (searchForm.operationEntityID !== 0) {
            getAllCollectionPointsByOperationEntityID();
        }

    }, [searchForm.operationEntityID]);

    useEffect(() => {
        handleSearch()
    }, [searchForm.operationEntityID, searchForm.collectionPointID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWTASKTEMPLATELISTING');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITTASKTEMPLATE');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !==undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchForm({
            ...searchForm,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });
        
        getAllGroups();
    }

    async function getEstates() {
        const result = await services.GetAllOperationEntityByGroupID(searchForm.groupID)
        setEstates(result)
    }

    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function getAllCollectionPointsByOperationEntityID() {
        setSearchForm({
            ...searchForm,
            collectionPointID: 0
        });
        const result = await services.getDivisions(searchForm.operationEntityID)
        setCollectionPoints(result)
    }

    async function getAllTaskTemplates(groupId, estateId, collectionPointID) {
        const data = await services.getGridByFilter(groupId, estateId, collectionPointID);

        return data;
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }


    function handleClick(item) {
        props.history.push({
            pathname: 'tasktemplate/addEdit',
            data: item,
            edit: true
        })
    }

    function handleChange(e){
        const target = e.target
        const value = target.name === 'isActive' ? target.checked: target.value
        
        setSearchForm({
            ...searchForm,
            [e.target.name]: value
        })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function clearButton() {

        setSearchForm({
            ...searchForm,
            groupID: 0,
            operationEntityID: 0,
        });
        setIsTableHide(true);
    }

    async function handleSearch() {
        setIsTableHide(true);
        if (searchForm.groupID != 0 && searchForm.operationEntityID != 0) {
            var data = await getAllTaskTemplates(searchForm.groupID, searchForm.operationEntityID, searchForm.collectionPointID);

            if (data.length > 0) {
                setIsTableHide(false);
            }

            destroyDataTable();
            setAllTaskTemplates(data);
            createDataTable();
        }
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
        <div className="row">
            <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Task Template"
                            isButtonEnable={permissionList.isAddEditEnabled}
                            buttonText="Add Factory Items"
                            path="tasktemplate/addEdit" />

                        <div className="card-body">

                            <form onSubmit={(e) => trackPromise( handleSearch(e))}>

                                <div className="form-group row">

                                <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth 
                                            id="groupID"
                                            name="groupID"
                                            value={searchForm.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            value={searchForm.operationEntityID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="collectionPointID">
                                            Collection Point
                                        </InputLabel>
                                        <Select
                                            fullWidth
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={searchForm.collectionPointID}
                                            onChange={(e) => handleChange(e)}
                                        >
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(collectionPoints)}
                                        </Select>
                                    </div>

                                </div>

                            </form>
                            <div className="table-responsive row-top-gap" hidden={isTableHide}>
                                <table id="example" className="display dataTable no-footer">
                                    <thead>
                                        <tr>
                                            <th>Task Name</th>
                                            <th>Task Category</th>
                                            <th>Task Description</th>
                                            <th>Task Expiration</th>
                                            <th>Collection Point</th>
                                            <th>No Of Workers</th>
                                            <th>Status</th>
                                            {permissionList.isAddEditEnabled ? <th>Action</th> : null}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <TableContent
                                            data={allTaskTemplates}
                                            hasEdit={permissionList.isAddEditEnabled}
                                            contentRowNames={contentRowNames}
                                            handleClick={handleClick}
                                        />
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}


